<div class="sdg-item" (click)="openDesc()">
  <img src="{{sdgData.iconUrl}}" class="sdg-icon" [alt]="sdgData.name" crossorigin="true">
  <div class="sdg-info" *ngIf="sdgOpen" [ngStyle]="{'background-color': sdgData.color}">
    <div class="sdg-title">
      <div class="sdg-number">{{sdgData.number}}</div>
      <div class="sdg-name">{{sdgData.name}}</div>
    </div>
    <p class="sdg-image"><img src="{{sdgData.iconUrl}}" alt=""></p>
    <p class="sdg-description">{{sdgData.description}}</p>
  </div>
</div>